import { format } from "date-fns";
import { Tooltip } from "react-tooltip";

import { TransactionModel } from "@interfaces/models";
import { formatAmount } from "@utils/index";

export const SearchTransactionItem = ({
  transaction,
  onDetails,
}: {
  transaction: TransactionModel;
  onDetails: () => void;
}) => (
  <>
    <div
      className="flex cursor-pointer flex-col gap-y-0.5 px-6 hover:bg-black-4"
      onClick={onDetails}
      data-tooltip-id={`tooltip-transaction-${transaction.uniqueId}`}
      data-tooltip-content={transaction.uniqueId}
      data-tooltip-variant="dark"
    >
      <div className="flex items-center justify-between font-bold">
        <div className="max-w-[230px] truncate text-300 *:text-black-54 md:max-w-[310px]">
          {transaction.category.title}
          <span> | </span>
          {transaction.subcategory.title}
          {transaction.refund && <span> • </span>}
          {transaction.refund && "Refund"}
        </div>
        <div
          className={
            transaction.type === "income" ? "text-green-100" : "text-black-100"
          }
        >
          {formatAmount(transaction.amount)}
        </div>
      </div>
      <div className="flex items-center justify-between text-100 capitalize text-black-54">
        <div className="max-w-[230px] truncate md:max-w-[310px]">
          {transaction.description}
        </div>
        <div>{format(new Date(transaction.date), "dd.MM.yyyy")}</div>
      </div>
    </div>
    <Tooltip id={`tooltip-transaction-${transaction.uniqueId}`} />
  </>
);
